// @ts-nocheck
goog.declareModuleId('yext.ui.components.Clickable');

export const Clickable = /** @type {?} */ (React.forwardRef(function(
  {
    tag,
    onClick,
    preventDefault = false,
    ...props
  },
  ref,
) {
  const click = e => {
    if (preventDefault) {
      e.preventDefault();
    }

    onClick(e);
  };

  const handleKeyDown = e => {
    const enterOrSpace =
      e.key === 'Enter'
      || e.key === ' '
      || e.key === 'Spacebar'
      || e.which === 13.0 // Keycodes.ENTER, removed closure usage
      || e.which === 32.0; // KeyCodes.SPACE, removed closure usage
    if (enterOrSpace && onClick) {
      click(e);
    }
  };

  const Tag = tag;
  return (
    <Tag
      role={onClick && 'button'}
      tabIndex={onClick && '0'}
      onClick={onClick ? click : undefined}
      onKeyDown={handleKeyDown}
      {...props}
      ref={ref}
    />
  );
}));
